import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import useApiFunction from "../../api/useApiFunction";
import valueContext from "../../customHook/useContext";
import Modal from "../Shared/Modal";

function MemberDetails() {
  const [core, setCore] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const { joinToken } = useContext(valueContext);

  const token = joinToken();
  const [limit, setLimit] = useState("");
  const [data, setData] = useState("");
  const [extendUsername, setExtendUsername] = useState("");

  const { formDataFunc } = useApiFunction();
  const navigate = useNavigate();

  async function getCore(core) {
    let body = {
      core_type: core
    };

    const res = await formDataFunc(
      "admin/get_core_member",
      JSON.stringify(body),
      "POST",
      token
    );
    if (res.status) {
      setData(res.msg);
    } else if (
      res.error &&
      (res.error === "ERROR_TOKEN_INVALID0" ||
        res.error === "ERROR_TOKEN_INVALID1" ||
        res.error === "user not registered" ||
        res.error === "ERROR_TOKEN_INVALID2" ||
        res.error === "ERROR_TOKEN_INVALID3" ||
        res.error === "unauthorized" ||
        res.error === "Your session has expierd Please login again 1" ||
        res.error === "Your session has expierd Please login again 2")
    ) {
      window.localStorage.removeItem("_A");
      window.localStorage.removeItem("_B");
      window.localStorage.removeItem("_C");
      navigate("/admin/login");
    } else if (res.error) {
      toast.warning(res.error, { autoClose: 2000 });
    } else {
      toast.warning(res.msg, {
        autoClose: 2000
      });
    }
  }

  async function deletemember(userName) {
    let body = {
      userName: userName
    };

    const res = await formDataFunc(
      "admin/delete-member",
      JSON.stringify(body),
      "POST",
      token
    );
    if (res.status) {
      setData(res.msg);
    } else if (
      res.error &&
      (res.error === "ERROR_TOKEN_INVALID0" ||
        res.error === "ERROR_TOKEN_INVALID1" ||
        res.error === "user not registered" ||
        res.error === "ERROR_TOKEN_INVALID2" ||
        res.error === "ERROR_TOKEN_INVALID3" ||
        res.error === "unauthorized" ||
        res.error === "Your session has expierd Please login again 1" ||
        res.error === "Your session has expierd Please login again 2")
    ) {
      window.localStorage.removeItem("_A");
      window.localStorage.removeItem("_B");
      window.localStorage.removeItem("_C");
      navigate("/admin/login");
    } else if (res.error) {
      toast.warning(res.error, { autoClose: 2000 });
    } else {
      toast.warning(res.msg, {
        autoClose: 2000
      });
    }
  }

  async function extendLimit(userName, e) {
    e.preventDefault();
    if (limit) {
      let body = {
        userName: userName,
        limit: limit
      };

      const res = await formDataFunc(
        "admin/extend-member-direct-limit",
        JSON.stringify(body),
        "POST",
        token
      );
      if (res.status) {
        setIsOpen(prv => !prv);
        getCore(1);
        setLimit("");
      } else if (
        res.error &&
        (res.error === "ERROR_TOKEN_INVALID0" ||
          res.error === "ERROR_TOKEN_INVALID1" ||
          res.error === "user not registered" ||
          res.error === "ERROR_TOKEN_INVALID2" ||
          res.error === "ERROR_TOKEN_INVALID3" ||
          res.error === "unauthorized" ||
          res.error === "Your session has expierd Please login again 1" ||
          res.error === "Your session has expierd Please login again 2")
      ) {
        window.localStorage.removeItem("_A");
        window.localStorage.removeItem("_B");
        window.localStorage.removeItem("_C");
        navigate("/admin/login");
      } else if (res.error) {
        toast.warning(res.error, { autoClose: 2000 });
      } else {
        toast.warning(res.msg, {
          autoClose: 2000
        });
      }
    }
  }
  useEffect(() => {
    getCore(core);
  }, [core]);
  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0 font-size-18">Member Details</h4>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-body">
                    <div className="table-responsive">
                      <div className="d-flex justify-content-between">
                        <h4 className="card-title table-head">
                          Member Details List
                        </h4>
                        <select
                          name="type"
                          className="level-option  card-title2"
                          onChange={e => setCore(e.target.value)}
                        >
                          <option value={1}>
                            {" "}
                            &nbsp;&nbsp;Core A&nbsp;&nbsp;
                          </option>
                          <option value={2}>
                            {" "}
                            &nbsp;&nbsp;Core B&nbsp;&nbsp;
                          </option>
                        </select>
                      </div>

                      <div className="table-responsive table-line">
                        <table
                          className="table align-middle mb-0"
                          id="order-listing"
                        >
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Name</th>
                              <th>userName</th>
                              <th>Tallwin ID</th>
                              {core == 2 ? <th>Ref Id</th> : <></>}
                              {core == 2 ? <th>Ref Name</th> : <></>}
                              <th>email</th>
                              <th>Mobile No.</th>
                              <th>Password</th>
                              <th>Core Incentive</th>
                              {core == 1 ? <th>Total Direct</th> : <></>}
                              {core == 1 && <th> Limit</th>}
                              {core == 1 && <th>Extend Limit</th>}
                              <th>Delete Member</th>
                            </tr>
                          </thead>
                          <tbody>
                            {data && data?.length > 0 ? (
                              data.map((data, i) => {
                                return (
                                  <tr>
                                    <th scope="row">{i + 1}</th>
                                    <td>{data.name}</td>
                                    <td>{data.userName}</td>
                                    <td>{data.twlUserName ? data.twlUserName : '--'}</td>
                                    {data.core == 2 ? (
                                      <td>{data.ref_id}</td>
                                    ) : (
                                      <></>
                                    )}
                                    {data.core == 2 ? (
                                      <td>
                                        {data.memberDetails
                                          ? data.memberDetails[0].name
                                          : "-"}
                                      </td>
                                    ) : (
                                      <></>
                                    )}
                                    <td>{data.email}</td>
                                    <td>{data.mobile_number}</td>
                                    <td>{data.password}</td>
                                    <td>
                                      {data.core_incentive
                                        ? data.core_incentive
                                        : "0.00"}
                                    </td>
                                    {data.core == 1 ? (
                                      <td>{data.no_of_direct}</td>
                                    ) : (
                                      <></>
                                    )}
                                    {data.core == 1 ? (
                                      data.flag &&
                                      data.flag >= data.no_of_direct ? (
                                        <td>
                                          {data.flag === 1 ? 5 : data.flag}
                                        </td>
                                      ) : (
                                        <td>
                                          {data.no_of_direct < 5
                                            ? 5
                                            : data.no_of_direct}
                                        </td>
                                      )
                                    ) : (
                                      <></>
                                    )}
                                    {core == 1 && (
                                      <td>
                                        <button
                                          className="btn btn-primary"
                                          style={{
                                            backgroundColor: "#00AD89",
                                            borderStyle: "none"
                                          }}
                                          onClick={() => {
                                            setExtendUsername(data.userName);
                                            setIsOpen(prv => !prv);
                                          }}
                                        >
                                          Extend
                                        </button>
                                      </td>
                                    )}

                                    <td>
                                      <button
                                        className="btn btn-primary"
                                        style={{
                                          backgroundColor: "#00AD89",
                                          borderStyle: "none"
                                        }}
                                        onClick={() =>
                                          deletemember(data.userName)
                                        }
                                      >
                                        <i className="fa fa-times"></i>
                                      </button>
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <p>NO DATA</p>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isOpen ? (
        <Modal show={isOpen} close={setIsOpen}>
          <div className="container-fluid">
            <div className="row" style={{ justifyContent: "center" }}>
              <div className="col-md-12">
                <div class="card profile-section">
                  <div class="card-body">
                    <div class="col-lg-12 col-md-12 col-sm-12">
                      <form>
                        <div class="form-group mb-3">
                          <label for="" class="sub-heading col-form-label">
                            Enter Limit
                          </label>
                          <input
                            type="number"
                            class="form-control mt-2"
                            placeholder="Enter your Extended Limit"
                            value={limit}
                            onChange={e => setLimit(e.target.value)}
                            required
                          />
                        </div>
                        <div class="">
                          <button
                            class="block-menu"
                            type="submit"
                            onClick={e => extendLimit(extendUsername, e)}
                          >
                            Extend Limit
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      ) : (
        <></>
      )}
      <ToastContainer />
    </>
  );
}

export default MemberDetails;
